module.exports = __webpack_public_path__ + "img/poker-c12.0c65d1b2.svg";